import React from 'react';
import type { HilPresentationAction } from '@bizfirst/hil-types';

interface HilChatPresetRowProps {
  presetActions: HilPresentationAction[];
  /** 'send' fires the preset immediately; 'fill' populates the text input for editing. */
  behavior: 'send' | 'fill';
  onSend: (action: HilPresentationAction, presetText: string) => void;
  onFill: (presetText: string) => void;
  disabled?: boolean;
}

function presetText(action: HilPresentationAction): string {
  return (action.Config?.presetText as string | undefined) ?? action.Label ?? action.ActionKey;
}

export function HilChatPresetRow({ presetActions, behavior, onSend, onFill, disabled }: HilChatPresetRowProps): React.JSX.Element | null {
  if (presetActions.length === 0) return null;

  return (
    <div className="hil-chat-preset-row">
      {presetActions.map(action => {
        const text = presetText(action);
        return (
          <button
            key={action.ActionKey}
            type="button"
            className="hil-chat-preset-chip"
            disabled={disabled || action.Enabled === false}
            onClick={() => (behavior === 'send' ? onSend(action, text) : onFill(text))}
          >
            {action.Label ?? text}
          </button>
        );
      })}
    </div>
  );
}
